<template>
  <CCard>
    <CCardHeader>
      Device List
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CDataTable
            hover
            small
            fixed
            table-filter
            sorter
            items-per-page-select
            :items-per-page="15"
            :fields="cmdbDeviceListFields"
            :items="devices"
            :noItemsView="{ noItems: 'No Item~' }"
            pagination
          >
            <template #last_heartbeat="{item}">
              <td class="py-2" v-if="item.last_heartbeat > 0">
                <CCardText color="green">{{ item.last_heartbeat | dateFormat}}</CCardText>
              </td>
              <td class="py-2" v-if="item.last_heartbeat === 0">
                <p style="color:red">No Heartbeat</p>
              </td>
            </template>
            <template #action="{item}">
              <td class="py-2">
                <CButtonGroup>
                  <CButton
                    color="info"
                    square
                    @click="requestMsg=item.uuid;requestMsgModal=true;"
                  >
                    Show UUID
                  </CButton>
                  <CButton
                    color="primary"
                    square
                    @click="$router.push('/cmdb/device/view/'+item.id)"
                  >
                    View
                  </CButton>
                  <CButton
                    color="danger"
                    square
                    @click="openDeleteModal(item)"
                  >
                    Delete
                  </CButton>

                </CButtonGroup>
              </td>
            </template>
          </CDataTable>
        </CCol>
      </CRow>
    </CCardBody>
    <CToaster :autohide="3000">
      <template v-for="toast in fixedToasts">
        <CToast
          :key="'toast' + toast"
          :show="true"
          :color="alertLevel"
          header="Alert"
        >
          {{ returnMsg }}
        </CToast>
      </template>
    </CToaster>
    <CModal
      title="Message"
      color="primary"
      :show.sync="requestMsgModal"
    >
      {{ requestMsg }}
      <template #footer>
        <CButton @click="requestMsgModal=false" color="primary">Close</CButton>
      </template>
    </CModal>
    <CModal
      title="Delete Device"
      color="danger"
      :show.sync="deleteModal"
    >
      <CAlert color="danger" fade>
        确定要删除设备「{{ deleteTarget.name }}」吗？其关联的所有 MAC 地址、DHCP 记录（含路由器上的真实 lease）都会被一并删除，且不可恢复。
      </CAlert>
      <template #footer>
        <CButtonGroup>
          <CButton color="secondary" @click="deleteModal=false">Cancel</CButton>
          <CButton color="danger" @click="deleteDevice">Delete</CButton>
        </CButtonGroup>
      </template>
    </CModal>
  </CCard>
</template>

<script>
const cmdbDeviceListFields = [
  { key: "id", label: "ID" },
  { key: "name", label: "Device Name" },
  { key: "type", label: "Type" },
  { key: "hostname", label: "Hostname" },
  { key: "main_ip", label: "Main IP" },
  { key: "last_heartbeat", label: "Last Heartbeat" },
  {
    key: "action",
    label: "Action",
    sorter: false,
    filter: false,
    _style: "width: 20%"
  }
];

export default {
  name: "DeviceList",
  data() {
    return {
      fixedToasts: 0,
      returnMsg: "",
      alertLevel: "success",
      requestMsgModal: false,
      requestMsg: null,
      deleteModal: false,
      deleteTarget: { id: null, name: '' },
      cmdbDeviceListFields,
      devices: [],
    };
  },
  mounted: function() {
    this.onLoadPage();
  },
  methods: {
    onLoadPage: function() {
      this.$axios.get("user/cmdb/device/list", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.devices = response.data.devices.map(item => {
              return {
                ...item,
                type: item.type.type_name
              }
            });
          }
        });
    },
    openDeleteModal: function(item) {
      this.deleteTarget = { id: item.id, name: item.name };
      this.deleteModal = true;
    },
    deleteDevice: function() {
      this.$axios.delete("user/cmdb/device/" + this.deleteTarget.id + "/delete", {})
        .then((response) => {
          if (response.data.code === 200) {
            this.deleteModal = false;
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
            this.onLoadPage();
          } else {
            this.deleteModal = false;
            this.requestMsg = response.data.msg;
            this.requestMsgModal = true;
          }
        });
    },
  }
};
</script>